import { render, staticRenderFns } from "./photocrop.vue?vue&type=template&id=10365dc2&scoped=true&"
import script from "./photocrop.vue?vue&type=script&lang=js&"
export * from "./photocrop.vue?vue&type=script&lang=js&"
import style0 from "./photocrop.vue?vue&type=style&index=0&id=10365dc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10365dc2",
  null
  
)

export default component.exports